import * as React from 'react';

import { useFieldContext } from '@april9au/react-common/ui/field';
import { cn } from '@april9au/react-common/utils';

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  const field = useFieldContext();

  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        className,
      )}
      id={field?.id}
      aria-describedby={field?.descriptionId}
      aria-labelledby={field?.labelId}
      disabled={field?.disabled}
      {...props}
    />
  );
}

export { Textarea };
